import { NavLink, useNavigate } from "react-router-dom";
import constant from "../../../../constants/constant";
import { checkPermissionsInArray } from "../../../../constants/utils";
import { AllPermissions } from "../../../../constants/permission";
import atoms from "../../../atoms";
import { TbLogout } from "react-icons/tb";
import { TabsPreviewProps } from "../interface";
import "../Header.scss"

const { Badge } = atoms;

export const TabsPreview = ({
    activeTab,
    handleNavClick,
    notificationCount,
    logout,
}: TabsPreviewProps) => {
    const navigate = useNavigate();
    return (
        <ul className="navbar-nav mb-2 mb-lg-0 gap-lg-3 gap-1">
            {
                <li className="nav-item cursor-pointer">
                    <div className="dropdown">
                        <div
                            className={`nav-link p-0 style-class ${activeTab === "productList" ? "active" : ""
                                }`}
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            Product
                        </div>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <NavLink
                                className={({
                                    isActive,
                                }) => `nav-link p-0 style-class position-relative 
                                    ${isActive &&
                                        activeTab === "productList" &&
                                        window?.location?.search ===
                                        `?${constant.PRODUCT_FILTER_TYPE.EYE_GLASSES}`
                                        ? "active"
                                        : ""
                                    }`}
                                to={`/product/list?${constant.PRODUCT_FILTER_TYPE.EYE_GLASSES}`}
                                data-bs-toggle={
                                    typeof window !== "undefined" && window.innerWidth < 825
                                        ? "collapse"
                                        : ""
                                }
                                data-bs-target="#navbarSupportedContent"
                                aria-controls="navbarSupportedContent"
                                aria-expanded="false"
                                aria-label="Toggle navigation"
                                onClick={() =>
                                    handleNavClick(constant.PRODUCT_FILTER_TYPE.EYE_GLASSES)
                                }
                            >
                                Frame
                            </NavLink>
                            <NavLink
                                className={({
                                    isActive,
                                }) => `nav-link p-0 style-class position-relative 
                                    ${isActive &&
                                        activeTab === "productList" &&
                                        window?.location?.search ===
                                        `?${constant.PRODUCT_FILTER_TYPE.SUN_GLASSES}`
                                        ? "active"
                                        : ""
                                    }`}
                                to={`/product/list?${constant.PRODUCT_FILTER_TYPE.SUN_GLASSES}`}
                                data-bs-toggle={
                                    typeof window !== "undefined" && window.innerWidth < 825
                                        ? "collapse"
                                        : ""
                                }
                                data-bs-target="#navbarSupportedContent"
                                aria-controls="navbarSupportedContent"
                                aria-expanded="false"
                                aria-label="Toggle navigation"
                                onClick={() =>
                                    handleNavClick(constant.PRODUCT_FILTER_TYPE.SUN_GLASSES)
                                }
                            >
                                Sunglass
                            </NavLink>
                            <NavLink
                                className={({
                                    isActive,
                                }) => `nav-link p-0 style-class position-relative 
                                    ${isActive &&
                                        activeTab === "productList" &&
                                        window?.location?.search ===
                                        `?${constant.PRODUCT_FILTER_TYPE.READING_GLASSES}`
                                        ? "active"
                                        : ""
                                    }`}
                                to={`/product/list?${constant.PRODUCT_FILTER_TYPE.READING_GLASSES}`}
                                data-bs-toggle={
                                    typeof window !== "undefined" && window.innerWidth < 825
                                        ? "collapse"
                                        : ""
                                }
                                data-bs-target="#navbarSupportedContent"
                                aria-controls="navbarSupportedContent"
                                aria-expanded="false"
                                aria-label="Toggle navigation"
                                onClick={() =>
                                    handleNavClick(constant.PRODUCT_FILTER_TYPE.READING_GLASSES)
                                }
                            >
                                Reading
                            </NavLink>
                            <NavLink
                                className={({
                                    isActive,
                                }) => `nav-link p-0 style-class position-relative 
                                    ${isActive &&
                                        activeTab === "productList" &&
                                        window?.location?.search ===
                                        `?${constant.PRODUCT_FILTER_TYPE.CONTACT_lENS}`
                                        ? "active"
                                        : ""
                                    }`}
                                to={`/product/list?${constant.PRODUCT_FILTER_TYPE.CONTACT_lENS}`}
                                data-bs-toggle={
                                    typeof window !== "undefined" && window.innerWidth < 825
                                        ? "collapse"
                                        : ""
                                }
                                data-bs-target="#navbarSupportedContent"
                                aria-controls="navbarSupportedContent"
                                aria-expanded="false"
                                aria-label="Toggle navigation"
                                onClick={() =>
                                    handleNavClick(constant.PRODUCT_FILTER_TYPE.CONTACT_lENS)
                                }
                            >
                                Contact Lens
                            </NavLink>
                        </div>
                    </div>
                </li>
            }
            {checkPermissionsInArray(AllPermissions.Sales_Tab) && (
                <li className="nav-item cursor-pointer">
                    <div className="dropdown">
                        <div
                            className={`nav-link p-0 style-class ${activeTab == "pending" ||
                                    activeTab == "deliver" ||
                                    location?.pathname?.split("/")[1] == "pending"
                                    ? "active"
                                    : ""
                                }`}
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            Sales
                            <Badge
                                count={
                                    Number(notificationCount?.pending_order_count) +
                                    Number(notificationCount?.saved_orders_count)
                                }
                                className="translate-middle mx-2 position-absolute"
                            />
                        </div>
                        {(checkPermissionsInArray(AllPermissions.Pending_Order_Tab) ||
                            checkPermissionsInArray(AllPermissions.Sales_History_Tab) ||
                            checkPermissionsInArray(AllPermissions.Cancelled_Order_Tab) ||
                            checkPermissionsInArray(AllPermissions.Sales_Return_Tab) ||
                            checkPermissionsInArray(
                                AllPermissions.Sales_Return_History_Tab
                            )) && (
                                <div
                                    className="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                >
                                    {checkPermissionsInArray(AllPermissions.STORE_SAVED_ORDER_TAB) && (
                                        <NavLink
                                            className={`nav-link p-0 style-class position-relative ${activeTab == "saved-orders" ||
                                                    window?.location?.search === "?saved-orders"
                                                    ? "active"
                                                    : ""
                                                }`}
                                            to="/saved-orders"
                                            data-bs-toggle={window.innerWidth < 825 ? "collapse" : ""}
                                            data-bs-target="#navbarSupportedContent"
                                            aria-controls="navbarSupportedContent"
                                            aria-expanded="false"
                                            aria-label="Toggle navigation"
                                            onClick={() => navigate("/saved-orders")}
                                        >
                                            Saved Orders
                                            <Badge count={notificationCount?.saved_orders_count} />
                                        </NavLink>
                                    )}
                                    {checkPermissionsInArray(AllPermissions.Pending_Order_Tab) && (
                                        <NavLink
                                            className={`nav-link p-0 style-class position-relative ${activeTab == "pending" ||
                                                    window?.location?.search === "?pendingOrder"
                                                    ? "active"
                                                    : ""
                                                }`}
                                            to="/pending-receipt"
                                            data-bs-toggle={window.innerWidth < 825 ? "collapse" : ""}
                                            data-bs-target="#navbarSupportedContent"
                                            aria-controls="navbarSupportedContent"
                                            aria-expanded="false"
                                            aria-label="Toggle navigation"
                                            onClick={() => navigate("/pending-receipt")}
                                        >
                                            In Process
                                            <Badge count={notificationCount?.pending_order_count} />
                                        </NavLink>
                                    )}
                                    {checkPermissionsInArray(AllPermissions.Sales_History_Tab) && (
                                        <NavLink
                                            className={`nav-link p-0 style-class ${activeTab == "deliver" ||
                                                    window?.location?.search === "?delivered"
                                                    ? "active"
                                                    : ""
                                                }`}
                                            to="/delivered"
                                            data-bs-toggle={window.innerWidth < 825 ? "collapse" : ""}
                                            data-bs-target="#navbarSupportedContent"
                                            aria-controls="navbarSupportedContent"
                                            aria-expanded="false"
                                            aria-label="Toggle navigation"
                                            onClick={() => navigate("/delivered")}
                                        >
                                            Sales History
                                        </NavLink>
                                    )}
                                    {checkPermissionsInArray(
                                        AllPermissions.Cancelled_Order_Tab
                                    ) && (
                                            <NavLink
                                                className={`nav-link p-0 style-class ${activeTab == "cancelled" ||
                                                        window?.location?.search === "?cancelled"
                                                        ? "active"
                                                        : ""
                                                    }`}
                                                to="/cancelled-order"
                                                data-bs-toggle={window.innerWidth < 825 ? "collapse" : ""}
                                                data-bs-target="#navbarSupportedContent"
                                                aria-controls="navbarSupportedContent"
                                                aria-expanded="false"
                                                aria-label="Toggle navigation"
                                                onClick={() => navigate("/cancelled-order")}
                                            >
                                                Cancelled Order
                                            </NavLink>
                                        )}
                                    {checkPermissionsInArray(AllPermissions.Sales_Return_Tab) && (
                                        <NavLink
                                            className={`nav-link p-0 style-class ${activeTab == "salesReturn" ? "active" : ""
                                                }`}
                                            to="/sales-return"
                                            data-bs-toggle={window.innerWidth < 825 ? "collapse" : ""}
                                            data-bs-target="#navbarSupportedContent"
                                            aria-controls="navbarSupportedContent"
                                            aria-expanded="false"
                                            aria-label="Toggle navigation"
                                            onClick={() => navigate("/sales-return")}
                                        >
                                            Sales Return
                                        </NavLink>
                                    )}
                                    {checkPermissionsInArray(
                                        AllPermissions.Sales_Return_History_Tab
                                    ) && (
                                            <NavLink
                                                className={`nav-link p-0 style-class`}
                                                to="/sales-return-history"
                                                data-bs-toggle={window.innerWidth < 825 ? "collapse" : ""}
                                                data-bs-target="#navbarSupportedContent"
                                                aria-controls="navbarSupportedContent"
                                                aria-expanded="false"
                                                aria-label="Toggle navigation"
                                                onClick={() => navigate("/sales-return-history")}
                                            >
                                                Sales Return History
                                            </NavLink>
                                        )}
                                </div>
                            )}
                    </div>
                </li>
            )}

            {checkPermissionsInArray(AllPermissions.Transfer_Tab) && (
                <li className="nav-item cursor-pointer">
                    <div className="dropdown">
                        <div
                            className={`nav-link p-0 style-class`}
                            id="dropdownMenu"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            Transfer
                            <span className="position-absolute">
                            <Badge count={notificationCount?.other_req_count} className="translate-middle mx-2" />
                            </span>
                        </div>
                        {(checkPermissionsInArray(AllPermissions.STAFF_Transfer_REQUEST_Tab) ||
                            checkPermissionsInArray(AllPermissions.STAFF_Internal_Transfer_Tab)) && (
                                <div className="dropdown-menu" aria-labelledby="dropdownMenu">
                                    {checkPermissionsInArray(AllPermissions.STAFF_Transfer_REQUEST_Tab) && (
                                        <NavLink
                                            className={`nav-link p-0 style-class`}
                                            to="/transfer-request"
                                            data-bs-toggle={window.innerWidth < 825 ? "collapse" : ""}
                                            data-bs-target="#navbarSupportedContent"
                                            aria-controls="navbarSupportedContent"
                                            aria-expanded="false"
                                            aria-label="Toggle navigation"
                                            onClick={() => navigate("/transfer-request")}
                                        >
                                            Transfer Request
                                            <Badge count={notificationCount?.other_req_count} className='translate-align' />
                                        </NavLink>
                                    )}
                                    {checkPermissionsInArray(AllPermissions.STAFF_Internal_Transfer_Tab) && (
                                        <NavLink
                                            className={`nav-link p-0 style-class`}
                                            to="/internal-transfer"
                                            data-bs-toggle={window.innerWidth < 825 ? "collapse" : ""}
                                            data-bs-target="#navbarSupportedContent"
                                            aria-controls="navbarSupportedContent"
                                            aria-expanded="false"
                                            aria-label="Toggle navigation"
                                            onClick={() => navigate("/internal-transfer")}
                                        >
                                            Internal Transfer
                                        </NavLink>
                                    )}
                                </div>
                            )}
                    </div>
                </li>
            )}
            {checkPermissionsInArray(AllPermissions.Warranty_Tab) && (
                <li className="nav-item cursor-pointer">
                    <div className="dropdown">
                        <div
                            className={`nav-link p-0 style-class`}
                            id="dropdownMenu"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            Warranty
                        </div>
                        {(checkPermissionsInArray(AllPermissions.New_Claim_Tab) ||
                            checkPermissionsInArray(AllPermissions.Claim_In_Process_Tab) ||
                            checkPermissionsInArray(AllPermissions.Claim_History_Tab)) && (
                                <div className="dropdown-menu" aria-labelledby="dropdownMenu">
                                    {checkPermissionsInArray(AllPermissions.New_Claim_Tab) && (
                                        <NavLink
                                            className={`nav-link p-0 style-class`}
                                            to="/warranty"
                                            data-bs-toggle={window.innerWidth < 825 ? "collapse" : ""}
                                            data-bs-target="#navbarSupportedContent"
                                            aria-controls="navbarSupportedContent"
                                            aria-expanded="false"
                                            aria-label="Toggle navigation"
                                            onClick={() => navigate("/warranty")}
                                        >
                                            New Claim
                                        </NavLink>
                                    )}
                                    {checkPermissionsInArray(
                                        AllPermissions.Claim_In_Process_Tab
                                    ) && (
                                            <NavLink
                                                className={`nav-link p-0 style-class`}
                                                to="/claimed"
                                                data-bs-toggle={window.innerWidth < 825 ? "collapse" : ""}
                                                data-bs-target="#navbarSupportedContent"
                                                aria-controls="navbarSupportedContent"
                                                aria-expanded="false"
                                                aria-label="Toggle navigation"
                                                onClick={() => navigate("/claimed")}
                                            >
                                                Claim In Process
                                            </NavLink>
                                        )}
                                    {checkPermissionsInArray(AllPermissions.Claim_History_Tab) && (
                                        <NavLink
                                            className={`nav-link p-0 style-class`}
                                            to="/claimed-history"
                                            data-bs-toggle={window.innerWidth < 825 ? "collapse" : ""}
                                            data-bs-target="#navbarSupportedContent"
                                            aria-controls="navbarSupportedContent"
                                            aria-expanded="false"
                                            aria-label="Toggle navigation"
                                            onClick={() => navigate("/claimed-history")}
                                        >
                                            Claim History
                                        </NavLink>
                                    )}
                                </div>
                            )}
                    </div>
                </li>
            )}
            {checkPermissionsInArray(AllPermissions.Prescription_Tab) && (
                <li className="nav-item ">
                    <NavLink
                        className=" nav-link p-0 style-class position-relative"
                        to="/prescription"
                        data-bs-toggle={window.innerWidth < 825 ? "collapse" : ""}
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                        onClick={() => navigate("/prescription")}
                    >
                        Prescription
                    </NavLink>
                </li>
            )}
            {checkPermissionsInArray(AllPermissions.Refund_Tab) && (
                <li className="nav-item cursor-pointer">
                    <div className="dropdown">
                        <div
                            className={`nav-link p-0 style-class`}
                            id="dropdownMenu"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            Refunds
                        </div>
                        {(checkPermissionsInArray(AllPermissions.Payment_Voucher_Tab) ||
                            checkPermissionsInArray(
                                AllPermissions.Payment_Voucher_History_Tab
                            )) && (
                                <div className="dropdown-menu" aria-labelledby="dropdownMenu">
                                    {checkPermissionsInArray(
                                        AllPermissions.Payment_Voucher_Tab
                                    ) && (
                                            <NavLink
                                                className={`nav-link p-0 style-class`}
                                                to="/payment-voucher"
                                                data-bs-toggle={window.innerWidth < 825 ? "collapse" : ""}
                                                data-bs-target="#navbarSupportedContent"
                                                aria-controls="navbarSupportedContent"
                                                aria-expanded="false"
                                                aria-label="Toggle navigation"
                                                onClick={() => navigate("/payment-voucher")}
                                            >
                                                Payment Voucher
                                            </NavLink>
                                        )}
                                    {checkPermissionsInArray(
                                        AllPermissions.Payment_Voucher_History_Tab
                                    ) && (
                                            <NavLink
                                                className={`nav-link p-0 style-class`}
                                                to="/payment-voucher-history"
                                                data-bs-toggle={window.innerWidth < 825 ? "collapse" : ""}
                                                data-bs-target="#navbarSupportedContent"
                                                aria-controls="navbarSupportedContent"
                                                aria-expanded="false"
                                                aria-label="Toggle navigation"
                                                onClick={() => navigate("/payment-voucher-history")}
                                            >
                                                Payment Voucher History
                                            </NavLink>
                                        )}
                                </div>
                            )}
                    </div>
                </li>
            )}
            {checkPermissionsInArray(AllPermissions.Online_Order_Tab) && (
                <li className="nav-item cursor-pointer">
                    <div className="dropdown">
                        <div
                            className={`nav-link p-0 style-class`}
                            id="dropdownMenu"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            Online Order
                            <Badge
                                count={
                                    notificationCount?.pending_online_order_count +
                                    notificationCount?.inprogess_online_order_count
                                }
                                className="translate-middle mx-2"
                            />
                        </div>
                        {
                            <div className="dropdown-menu" aria-labelledby="dropdownMenu">
                                {checkPermissionsInArray(
                                    AllPermissions.E_Pending_Order_Tab
                                ) && (
                                        <NavLink
                                            className={`nav-link p-0 style-class`}
                                            to="/online/e-orders"
                                            data-bs-toggle={window.innerWidth < 825 ? "collapse" : ""}
                                            data-bs-target="#navbarSupportedContent"
                                            aria-controls="navbarSupportedContent"
                                            aria-expanded="false"
                                            aria-label="Toggle navigation"
                                            onClick={() => navigate("/online/e-orders")}
                                        >
                                            E-Pending Order
                                            <Badge
                                                count={notificationCount?.pending_online_order_count}
                                            />
                                        </NavLink>
                                    )}
                                {checkPermissionsInArray(AllPermissions.E_InProcess_Tab) && (
                                    <NavLink
                                        className={`nav-link p-0 style-class`}
                                        to="/online/in-process"
                                        data-bs-toggle={window.innerWidth < 825 ? "collapse" : ""}
                                        data-bs-target="#navbarSupportedContent"
                                        aria-controls="navbarSupportedContent"
                                        aria-expanded="false"
                                        aria-label="Toggle navigation"
                                        onClick={() => navigate("/online/in-process")}
                                    >
                                        E-In Process
                                        <Badge
                                            count={notificationCount?.inprogess_online_order_count}
                                        />
                                    </NavLink>
                                )}
                                {checkPermissionsInArray(
                                    AllPermissions.E_Sales_History_Tab
                                ) && (
                                        <NavLink
                                            className={`nav-link p-0 style-class`}
                                            to="/online/sales-history"
                                            data-bs-toggle={window.innerWidth < 825 ? "collapse" : ""}
                                            data-bs-target="#navbarSupportedContent"
                                            aria-controls="navbarSupportedContent"
                                            aria-expanded="false"
                                            aria-label="Toggle navigation"
                                            onClick={() => navigate("/online/sales-history")}
                                        >
                                            E-Sales History
                                        </NavLink>
                                    )}
                                {checkPermissionsInArray(
                                    AllPermissions.E_Cancelled_Order_Tab
                                ) && (
                                        <NavLink
                                            className={`nav-link p-0 style-class`}
                                            to="/online/cancelled-history"
                                            data-bs-toggle={window.innerWidth < 825 ? "collapse" : ""}
                                            data-bs-target="#navbarSupportedContent"
                                            aria-controls="navbarSupportedContent"
                                            aria-expanded="false"
                                            aria-label="Toggle navigation"
                                            onClick={() => navigate("/online/cancelled-history")}
                                        >
                                            E-Cancelled Order
                                        </NavLink>
                                    )}
                            </div>
                        }
                    </div>
                </li>
            )}
            <li
                className="d-none nav-item d-block d-md-none ms-3 cursor-pointer "
                onClick={() => logout()}
            >
                <TbLogout />
                <span className="p-2">Logout</span>
            </li>
        </ul>
    );
};
